/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectType } from './subjectType.model';
import { PaymentMethodCode } from './paymentMethodCode.model';
import { NonCadastralSource } from './nonCadastralSource.model';
import { HouseNumberType } from './houseNumberType.model';


export interface NonCadastralSubjectSearch { 
    account?: string;
    bankCode?: string;
    cadastralSubjectId?: number;
    castObce?: string;
    cisloDomovni?: number;
    cisloOrientacni?: string;
    cpCe?: HouseNumberType;
    delivered?: boolean;
    iban?: string;
    ico?: string;
    id?: number;
    jmeno?: string;
    mestskaCast?: string;
    nazev?: string;
    obec?: string;
    okres?: string;
    opsubId?: number;
    opsubType?: SubjectType;
    orderName?: string;
    paymentMethod?: PaymentMethodCode;
    payoutRent?: boolean;
    prijmeni?: string;
    psc?: string;
    rodneCislo?: string;
    source?: NonCadastralSource;
    specSym?: string;
    stat?: string;
    subjectPartner1?: NonCadastralSubjectSearch;
    subjectPartner2?: NonCadastralSubjectSearch;
    swift?: string;
    titulPredJmenem?: string;
    titulZaJmenem?: string;
    ulice?: string;
    uniqueId?: string;
    uniqueIdPartner1?: string;
    uniqueIdPartner2?: string;
    varSym?: string;
}
export namespace NonCadastralSubjectSearch {
}


